"use client";
import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import shared from "./shared";
import styled from "styled-components";
import {
  textColorInverted,
  blue20,
  blue10,
  blue25,
  blue40,
  accentColorPrimary,
  setAppearanceConstantLocal
} from "@churchofjesuschrist/eden-style-constants";
const [buttonPrimaryHoverDef, buttonPrimaryHover] = setAppearanceConstantLocal(
  "button-primary-hover",
  {
    light: blue25,
    dark: blue10,
    prefix: "eden"
  }
);
const [buttonPrimaryActiveDef, buttonPrimaryActive] = setAppearanceConstantLocal("button-primary-active", {
  light: blue40,
  dark: blue20,
  prefix: "eden"
});
const Component = styled.button`
  ${shared};
  ${buttonPrimaryHoverDef};
  ${buttonPrimaryActiveDef};

  background-color: ${accentColorPrimary};

  color: ${textColorInverted};

  @media (any-hover: hover) {
    &:hover {
      background: ${buttonPrimaryHover};
      color: ${textColorInverted};
    }
  }

  &:active,
  &[aria-pressed="true"] {
    background: ${buttonPrimaryActive};
  }

  &:is(a):visited:not(:active) {
    color: ${textColorInverted};
  }
`;
const PrimaryComponent = ({
  href,
  disabled,
  renderAs = href && !disabled ? "a" : "button",
  type = renderAs === "button" ? "button" : void 0,
  small,
  fullWidth,
  ...props
}, ref) => /* @__PURE__ */ jsx(
  Component,
  {
    ...props,
    ref,
    type,
    href,
    disabled,
    $fullWidth: fullWidth,
    $small: small,
    as: renderAs,
    children: props.children
  }
);
const Primary = forwardRef(PrimaryComponent);
Primary.displayName = "Primary";
var Primary_default = Primary;
export {
  Primary_default as default
};
